import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Divider,
  useTheme,
} from "@mui/material";
import {
  Person as PersonIcon,
  Work as WorkIcon,
  Badge as BadgeIcon,
} from "@mui/icons-material";

const CandidateInfoCard = ({ candidate }) => {
  const theme = useTheme();

  return (
    <Card
      elevation={2}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        boxShadow:
          theme.palette.mode === "dark"
            ? "0px 1px 3px rgba(0, 0, 0, 0.3)"
            : "0px 1px 3px rgba(0, 0, 0, 0.1)",
        borderRadius: 3,
      }}
    >
      <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Typography
          variant="body1"
          sx={{ fontWeight: 600, mb: 2, color: theme.palette.text.primary }}
        >
          Candidate Information
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", mb: 2, minWidth: 0 }}>
          <Avatar
            sx={{
              width: 45,
              height: 45,
              bgcolor: theme.palette.primary.main,
              mr: 2,
            }}
          >
            <PersonIcon sx={{ fontSize: 32 }} />
          </Avatar>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                overflowWrap: "anywhere",
              }}
            >
              {candidate.name}
            </Typography>
            {/* <Typography
              variant="caption"
              color="text.secondary"             
              sx={{ overflowWrap: "anywhere"}}
            >
              {candidate.email}
            </Typography> */}
          </Box>
        </Box>

        <Divider />

        <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
          <WorkIcon
            sx={{ fontSize: 20, color: theme.palette.text.secondary, mr: 1.5 }}
          />
          <Box>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
            >
              Position
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 500, color: theme.palette.text.primary }}
            >
              {candidate.position}
            </Typography>
          </Box>
        </Box>

        {/* <Box sx={{ display: "flex", alignItems: "center" }}>
          <BadgeIcon
            sx={{ fontSize: 20, color: theme.palette.text.secondary, mr: 1.5 }}
          />
          <Box>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
            >
              Interview ID
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 500, color: theme.palette.text.primary }}
            >
              {candidate.interviewId}
            </Typography>
          </Box>
        </Box> */}
      </CardContent>
    </Card>
  );
};

export default CandidateInfoCard;
